import React from 'react';

const PaymentFailed = () => {
  return (
    <div className="payment-failed-container">
      <div className="payment-failed-card">
        <div className="payment-failed-icon-container">
        <div className='payment-failed-sec'>
        <svg
            className="payment-failed-icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3m0 3v.75m9-3.75a9 9 0 1 0-18 0 9 9 0 0 0 18 0Z"
            ></path>
          </svg>
        </div>
        </div>
        <h1 className="payment-failed-title">Payment Failed</h1>
        <p className="payment-failed-message">
          Unfortunately, your payment could not be processed.
        </p>
        <div className="payment-failed-button-container">
          <a
            href="https://quaffee-club-customer.bosselt.com/summary"
            className="payment-failed-retry-button"
          >
            Retry Payment
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
